import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-beta-banner',
  templateUrl: './beta-banner.component.html',
  styleUrls: ['./beta-banner.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ 'max-height': '0px' }),
        animate('2000ms ease-in-out', style({ 'max-height': '1000px' })),
      ]),
      transition(':leave', [animate('500ms ease-in-out', style({ opacity: 0.5, 'max-height': '0px' }))]),
    ]),
  ],
})
export class BetaBannerComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}
}
